import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {
  getDeliveryNote,
  getDeliveryNoteById,
  getParticularPage,
  getNext,
  getPrevious,
  handleSearch,
  getSaleOrderDetailsById,
  getDeliveryNoteAdditionalChargeList,
  createDeliveryNote,
} from "./thunk";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../../../../Utils/dateFormater";

const initialState = {
  deliveryNotes: [],
  edit: false,
  deliveryNote: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingDeliveryNote: false,
  loadingNext: false,
  loadingDetails: false,
  saleOrder: null,
  additionalCharges: [],
  deliveryNoteDetails: [
    {
      unique: uuidv4(),
      product: null,
      description: "",
      availableStock: "",
      actualQty: "",
      unit: "",
      altUnit: null,
      altQuantity: "",
      amount: "",
      rate: "",
      requiredDate: dateFormater(new NepaliDate()),
    },
  ],
  saveAndContinue: false,
  showCreateModal: false,

  selectedSaleOrder: null,
  selectedOrderDetails: [],
  selectedAdditionalCharges: [],
};

export const deliveryNoteSlice = createSlice({
  name: "deliveryNote",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setSaveAndContinue: (state, { payload }) => {
      state.saveAndContinue = payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    setMainOrder: (state, action) => {
      state.selectedSaleOrder = action.payload;
    },
    setOrderDetails: (state, action) => {
      state.selectedOrderDetails = action.payload.map((value) => ({
        ...value,
        description: value.product?.name || "",
      }));
    },
    setAdditionalDetails: (state, action) => {
      state.selectedAdditionalCharges = action.payload.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    },

    updateDeliveryNoteAddCharges: (state, action) => {
      state.additionalCharges = action.payload;
    },
    // setSaleOrder: (state, action) => {
    //   state.saleOrder = action.payload;
    // },
    // when detail is added from sale order
    setDeliveryNoteDetails: (state, action) => {
      state.deliveryNoteDetails = [
        ...action.payload,
        {
          unique: uuidv4(),
          product: null,
          description: "",
          availableStock: "",
          actualQty: "",
          unit: "",
          altUnit: null,
          altQuantity: "",
          amount: "",
          rate: "",
          requiredDate: dateFormater(new NepaliDate()),
        },
      ];
    },
    setAdditionalCharges: (state, action) => {
      state.additionalCharges = action.payload;
    },

    deliveryNoteDetailsUpdated: (state, action) => {
      state.deliveryNoteDetails = action.payload;
    },

    clearSelectedOrderData: (state) => {
      state.selectedSaleOrder = null;
      state.selectedOrderDetails = [];
      state.selectedAdditionalCharges = [];
    },
    clearDeliveryNoteDetails: (state, action) => {
      state.saleOrder = null;
      state.deliveryNoteDetails = [
        {
          unique: uuidv4(),
          product: null,
          description: "",
          availableStock: "",
          actualQty: "",
          unit: "",
          altUnit: null,
          altQuantity: "",
          amount: "",
          rate: "",
          requiredDate: dateFormater(new NepaliDate()),
        },
      ];
      state.additionalCharges = [];
    },

    clearAllDeliveryNote: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingDeliveryNote = false;
      state.deliveryNote = null;
      state.selectedSaleOrder = null;
      state.selectedOrderDetails = [];
      state.selectedAdditionalCharges = [];

      state.saleOrder = null;
      state.deliveryNoteDetails = [
        {
          unique: uuidv4(),
          product: null,
          description: "",
          availableStock: "",
          actualQty: "",
          unit: "",
          altUnit: null,
          altQuantity: "",
          amount: "",
          rate: "",
          requiredDate: dateFormater(new NepaliDate()),
        },
      ];
    },
  },
  extraReducers: (builder) => {
    // for listing of AdditionalChargeCost
    builder.addCase(createDeliveryNote.pending, (state) => {
      state.loadingCreate = true;
    });
    builder.addCase(createDeliveryNote.fulfilled, (state, action) => {
      state.loadingCreate = false;
    });
    builder.addCase(createDeliveryNote.rejected, (state) => {
      state.loadingCreate = false;
    });
    builder.addCase(getDeliveryNoteAdditionalChargeList.pending, (state) => {
      state.additionalCharges = null;
    });
    builder.addCase(getDeliveryNoteAdditionalChargeList.fulfilled, (state, action) => {
      state.additionalCharges = action.payload.data.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(getDeliveryNoteAdditionalChargeList.rejected, (state) => {
      state.additionalCharges = null;
    });

    // getDeliveryNoteById
    builder.addCase(getSaleOrderDetailsById.pending, (state) => {
      state.loadingDetails = true;
      // state.deliveryNoteDetails = null;
    });
    builder.addCase(getSaleOrderDetailsById.fulfilled, (state, action) => {
      state.loadingDetails = false;
      // state.saleOrder = action.payload.data;
      // state.deliveryNoteDetails = action.payload.data?.saleOrderDetails.map((value) => {
      //   return { ...value, unique: uuidv4() };
      // });
      // state.additionalCharges = action.payload.data.salesOrderMainAdditionalChargeCost;
    });
    builder.addCase(getSaleOrderDetailsById.rejected, (state) => {
      state.loadingDetails = false;
      // state.deliveryNoteDetails = null;
    });
    builder.addCase(getDeliveryNoteById.pending, (state) => {
      state.loading = true;
      state.deliveryNote = null;
    });
    builder.addCase(getDeliveryNoteById.fulfilled, (state, action) => {
      state.edit = true;
      state.loading = false;
      state.deliveryNote = action.payload.data;
      state.deliveryNoteDetails = action.payload.data?.deliveryNotesDetails.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(getDeliveryNoteById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.deliveryNote = null;
    });
    builder.addMatcher(
      isAnyOf(
        getDeliveryNote.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingDeliveryNote = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getDeliveryNote.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingDeliveryNote = false;
        state.deliveryNotes = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getDeliveryNote.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingDeliveryNote = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  setSaveAndContinue,
  goToPage,
  setMainOrder,
  setOrderDetails,
  setAdditionalDetails,
  deliveryNoteDetailsUpdated,

  updateDeliveryNoteAddCharges,
  setSaleOrder,
  setDeliveryNoteDetails,

  setAdditionalCharges,
  clearSelectedOrderData,
  clearSaleOrderDetails,
  clearDeliveryNoteDetails,
  clearAllDeliveryNote,
} = deliveryNoteSlice.actions;

export default deliveryNoteSlice.reducer;
